function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DiscretionaryDiscountsByCurrencySelector } from 'invision-core/src/components/metadata/discounts/discounts.selectors';
import { cloneDeep } from 'lodash';
import * as DiscountActions from '../../../reducers/actions/discount.actions';
import LocaleKeys from '../../../locales/keys';
import { DiscountFormSelector } from '../../../reducers/selectors/discount.selectors';
var DiscountDialogController = /*#__PURE__*/function () {
  function DiscountDialogController($ngRedux) {
    _classCallCheck(this, DiscountDialogController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      formLookup: {
        discount: LocaleKeys.DISCOUNT_DIALOG.DISCRETIONARY_DISCOUNT,
        reason: LocaleKeys.DISCOUNT_DIALOG.REASON
      },
      LocaleKeys: LocaleKeys,
      onReasonSelected: this.onReasonSelected.bind(this)
    });
  }
  return _createClass(DiscountDialogController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          discountForm: DiscountFormSelector(store),
          discretionaryDiscountsByCurrency: DiscretionaryDiscountsByCurrencySelector(store)
        };
      };
      var controllerActions = {
        clearDiscountForm: DiscountActions.clearDiscountForm,
        setDiscountForm: DiscountActions.setDiscountForm
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.selectedDiscounts = cloneDeep(this.state.discountForm.selectedDiscounts) || {};
    }
  }, {
    key: "discretionaryDiscounts",
    get: function get() {
      return this.state.discretionaryDiscountsByCurrency[this.currency] || [];
    }
  }, {
    key: "onDiscountSelected",
    value: function onDiscountSelected() {
      this.actions.setDiscountForm(Object.assign({}, this.state.discountForm, {
        selectedDiscounts: this.selectedDiscounts
      }));
    }
  }, {
    key: "onReasonSelected",
    value: function onReasonSelected(item) {
      this.actions.setDiscountForm(Object.assign({}, this.state.discountForm, {
        discountReason: item
      }));
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this._resetForm();
      this.onClose()();
    }
  }, {
    key: "handleKeypressForm",
    value: function handleKeypressForm(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.handleSubmitForm();
      }
    }
  }, {
    key: "handleSubmitForm",
    value: function handleSubmitForm() {
      this.discountDialogForm.$submitted = true;
      if (this.discountDialogForm.$valid) {
        this.onSubmit()(Object.assign({}, this.state.discountForm, {
          selectedDiscounts: this.selectedDiscounts
        }));
        this._resetForm();
      }
    }
  }, {
    key: "_resetForm",
    value: function _resetForm() {
      this.selectedDiscounts = {};
      this.actions.clearDiscountForm();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges() {
      if (this.state && this.state.discountOptions) {
        this.selectedDiscountId = this.state.discountOptions[0].value;
      }
    }
  }]);
}();
export default {
  bindings: {
    applyToRenewal: '<?',
    formErrors: '<',
    isLoading: '<',
    currency: '<',
    onClose: '&',
    onSubmit: '&'
  },
  template: require('./discount.dialog.html'),
  controller: DiscountDialogController
};